/* eslint-disable import/prefer-default-export */
import axios, { CancelTokenSource } from 'axios'

import NotificationNormalizer from 'normalizer/Notifications/NotificationNormalizer'
import NotificationECE from 'utils/__interfaces/Notifications/NotificationECE'
import { TIME_OUT_TABLE } from 'utils/__consts/Common/Table'
import isCancel from 'utils/Common/api-utils'

let cancelToken: CancelTokenSource

export const getNotifications = async (
  pageIndex: number,
  pageSize: number,
  idContactWdh: string
): Promise<{ results: NotificationECE[]; isTimeOut: boolean }> => {
  if (!idContactWdh) Promise.resolve({ results: [], isTimeOut: false })
  const url = `${process.env.REACT_APP_BASE_API_URL}/notifications`

  const params = new URLSearchParams({
    page: String(pageIndex),
    perPage: String(pageSize),
  })

  try {
    const resp = await axios({
      method: 'GET',
      url,
      params,
      timeout: TIME_OUT_TABLE,
    })
    if (resp?.data) {
      const results = NotificationNormalizer.normalize(resp?.data)
      return Promise.resolve({ results, isTimeOut: false })
    }
    return Promise.resolve({ results: [], isTimeOut: false })
  } catch (err) {
    if (err?.code === 'ECONNABORTED') {
      return Promise.resolve({
        results: [],
        isTimeOut: true,
      })
    }
    throw new Error(`Erreur lors de l'appel api NH : liste des notifications`)
  }
}

export const updateNotification = async (id: number): Promise<number> => {
  const url = `${process.env.REACT_APP_BASE_API_URL}/notifications/${id}`

  cancelToken = axios.CancelToken.source()

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data: {},
      cancelToken: cancelToken.token,
    })

    return resp.status
  } catch (err) {
    if (isCancel(err)) {
      return Promise.resolve(err)
    }
    console.error(err)
    throw new Error(`Erreur lors de l'appel api NH : Modifier une notification`)
  }
}

export const deleteNotification = async (id: number): Promise<number> => {
  const url = `${process.env.REACT_APP_BASE_API_URL}/notifications/${id}`

  try {
    const resp = await axios({
      method: 'DELETE',
      url,
      data: {},
    })
    return resp.status
  } catch (err) {
    console.error(err)
    throw new Error(
      `Erreur lors de l'appel api NH : Supprimer une notification`
    )
  }
}
